import "core-js/stable";
import "regenerator-runtime/runtime";
import DeviceDetection from "oc-commons/DeviceDetection";
import "oc-commons/extensions/StringExtensions.js";
import I18N from "oc-I18N";
import JacoApp from "oc-jaco3d/JacoApp";
import "oc-threejs/patched/OrbitControls.oc.js";
import * as THREE from "three";
import { renderLoading, renderUI, renderInspirationEditorUI, UI } from "./ui/UI";
import { SceneNode } from "oc-scene-editor/nodes/SceneNode";
import UniversalLoader from "oc-threejs/loader/UniversalLoader";
import Arrangement from "./arrangement/Arrangement";
import { RichMetadata } from "./RichMetadata";
import Wkfg2BackendApi from "../../../Wirtschaftswunder/oc-modules/oc-app/Wkfg2BackendApi";
import Stage from "oc-threejs/Stage";
import { matchPath } from "react-router";
import InteractionHandler from "./InteractionHandler";
import Saving from "./ui/organisms/popovers/Saving";
import Urls from "oc-commons/Urls";
import Scenes from "oc-threejs/Scenes";
import Debugs from "oc-threejs/Debugs";

window.THREE = THREE;

let minLoadingTime = location.hostname === "localhost" ? 0 : 2000;
let startInitialLoading = undefined;
export class App extends JacoApp {
  constructor(container, configurationSettings) {
    super("oc-messestand", container, configurationSettings);
    renderLoading(container);
    startInitialLoading = Date.now();
    this.ui = {
      dirty: () => this.updateUI(),
    };
    this.changeCurrency();

    APP.on("afterUpdate3d", () => {
      this.arrangement?.booth?.checkInteriorCollisions();
    });
  }

  async _appInitialize(settings) {
    this._appInitializeFromAbstractApp(settings);

    this.initReadyEventTrigger();

    await this.loadInitialConfigData();

    this.initStage();
    this.initControls();

    console.time("SceneNode");
    this.initSceneNode();
    console.timeEnd("SceneNode");

    this.initArrangement();
    this.initUI(() => {
      this.initInteractionHandler();
    });
    this.loadInitialConfigurationFromApp();
    this.dirty();
  }

  saveAction() {
    APP.arrangement.setDialog({
      content: Saving(),
    });
  }

  async saveInspirationAction() {
    const flatMetadata = APP.richMetadata.flatMetadata;

    try {
      APP.updateConfiguration();
      const configurationBefore = APP.configuration?.Code ? true : false;
      const code = await new Promise((resolve) =>
        APP.save({
          callback: (configuration) => {
            resolve(configuration.Code);
          },
          quiet: true,
          preferUpdate: true,
          noFotoSnapshots: true,
          skipURLUpdate: true,
          modifyBeforeWrite: (configuration) => {
            configuration.Inspiration = true;
            // configuration.Boothset = APP.currentBoothSet;
            configuration.GeneratedThumbnail =
              "/Konfiguration/" + configuration.Code + "/Inspiration.jpg";
            // configuration.Json.boothName = APP.arrangement.state.booth.Name;
          },
        })
      );

      if (!configurationBefore) {
        //Booth erstellen
        const metadataBooth = flatMetadata.Booths.find(
          (booth) => booth.Name == APP.arrangement.state.booth.Name
        );
        const newBoothName = `${metadataBooth.Name}_${code}`;
        const newMetadataBooth = {
          ...metadataBooth,
          Inspiration: code,
          Name: newBoothName,
          id: undefined,
        };
        await APP.wkfgBackendApi.saveMetadata("Booths", "create", newMetadataBooth);

        // companyName Eintrag erstellen, falls vorhanden
        if(APP.arrangement.booth.jaco3d.companyName?.exists) {
          const newComapnyNameEntry = {
            Booth: newBoothName,
            ColorSet: "CompanyName"
          }
          await APP.wkfgBackendApi.saveMetadata("ColorSetsForCompanyName", "create", newComapnyNameEntry);
        }
        // BoothsForBoothSets Einträge duplizieren
        const boothsForBoothSetsEntrys = flatMetadata.BoothsForBoothSets.filter((entry) => {
          return entry.Booth == metadataBooth.Name;
        }).map((entry) => {
          return { ...entry, Booth: newBoothName, BoothSet: APP.currentBoothSet, id: undefined };
        });
        const promiseMap = boothsForBoothSetsEntrys.map((BoothsForBoothSetsEntry) => {
          return APP.wkfgBackendApi.saveMetadata(
            "BoothsForBoothSets",
            "create",
            BoothsForBoothSetsEntry
          );
        });
        await Promise.all(promiseMap);

        // FormsForBooths duplizieren
        const formsForBoothsEntrys = flatMetadata.FormsForBooths.filter((entry) => {
          return entry.Booth == metadataBooth.Name;
        }).map((entry) => {
          return { ...entry, Booth: newBoothName, id: undefined };
        });
        const promiseMap2 = formsForBoothsEntrys.map((formsForBoothsEntry) => {
          return APP.wkfgBackendApi.saveMetadata("FormsForBooths", "create", formsForBoothsEntry);
        });
        await Promise.all(promiseMap2);
        await APP.richMetadata.init();
      } else {
        const currentName = flatMetadata.Booths.find(
          (Booth) => Booth.Inspiration == APP.configuration.Code
        ).Name;
        // BoothsForBoothSets Einträge duplizieren
        const boothsForBoothSetsEntrys = flatMetadata.BoothsForBoothSets.filter((entry) => {
          return entry.Booth == currentName;
        }).map((entry) => {
          return {
            ...entry,
            BoothSet: APP.currentBoothSet,
          };
        });
        const promiseMap = boothsForBoothSetsEntrys.map((BoothsForBoothSetsEntry) => {
          return APP.wkfgBackendApi.saveMetadata(
            "BoothsForBoothSets",
            "update",
            BoothsForBoothSetsEntry
          );
        });
        await Promise.all(promiseMap);
      }

      APP.arrangement.setDialog(undefined);
    } catch (e) {
      console.error("Error", e);
    }

    // BoothsForBoothSets anpassen

    // FormsForBooths anpassen
  }

  loadInitialConfigData() {
    I18N.autodetectLanguage();
    return this.loadConfigData({
      code: window.location.hash.match(/\/configurator\/\w{10}/)?.[0].substr(-10),
      metamodell: true,
      i18n: true,
    });
  }

  changeLang = async () => {
    const otherLang = I18N.getLanguage() === "en" ? "zh" : "en";
    const link =
      this.settings.wkfgBackendUrl +
      "metamodell/config?Code=&metamodel=false&metadata=true&i18n=true&lang=" +
      otherLang;
    await $.ajax(link).done((res) => {
      I18N.setKeyValueMap(res.i18n_json);
      this.metadata = res.metadata; // Die beiden nächsten Zeilen können leider nichts mit ins promise, da sonst das await nicht komplett funktioniert
    });
    this.richMetadata = new RichMetadata(this.metadata);
    await this.richMetadata.init();
    I18N.setLanguage(otherLang);
    APP.settings.currentLang = otherLang;
    this.changeCurrency();
    this.arrangement.partslist.update();
    this.arrangement.updateLanguage();
    APP.ui.dirty();
  };

  changeCurrency = () => {
    const newCurrency = I18N.getLanguage() === "en" ? "USD" : "TWD";
    this.formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: newCurrency,
      notation: "standard",
      currencyDisplay: "code",
    });
  };

  createStage() {
    return new (class extends Stage {
      createLights(name = STAGE.settings.lightSettingsName, sceneImporter = APP.sceneImporter) {
        return [];
      }
    })(this.settings.stage);
  }

  initControls() {
    this.controls = STAGE.orbitControl;
  }

  initInteractionHandler() {
    const app = $("#cfg-app");
    this.interactionHandler = new InteractionHandler(app);
    this.interactionHandler.setSceneDroppable();
  }

  initStage(envName = null) {
    super.initStage(envName);
    APP.renderer = STAGE.renderer;
    APP.scene = STAGE.scene;
    APP.camera = STAGE.camera;
    APP.controls = STAGE.orbitControl;
  }

  initStagetoDOM() {
    const stageElement = document.querySelector(".stage");
    stageElement.prepend(this.renderer.domElement);
    STAGE.setRendererToSize();
    _.delay(() => STAGE.setRendererToSize(), 3000);
    window.addEventListener(
      "resize",
      _.debounce(() => STAGE.setRendererToSize(), 300)
    );
  }

  setStageFromConfiguration(configuration = {}) {
    const params = this.parseParams();
    this.configuration = configuration;
    console.log("setStageFromConfiguration", this.configuration);
    const mergedConfiguration = this.arrangement.createDefaultArrangement(params, configuration);

    APP.dirty();
  }

  initSceneNode() {
    const sceneNode = (this.sceneNode = new SceneNode());
    this.materials = sceneNode.createMaterialsFactory();
    UniversalLoader.setMaterialFactory(this.materials);
    sceneNode.init();
    APP.updateUI();
  }

  initUI(cb) {
    this.updateUI(cb);
  }

  updateUI(cb = () => console.log("defaultUIInitCallback")) {
    const innerRender = () => {
      const t0 = performance.now();
      if (this.settings.inspirationEditorMode) {
        renderInspirationEditorUI(this.container);
      } else {
        renderUI(this.container);
      }
      const t1 = performance.now();
      console.log("UI-full rerender", t1 - t0, "ms");
    };
    if (Date.now() - startInitialLoading > minLoadingTime) {
      innerRender();
      cb();
    } else {
      setTimeout(() => {
        innerRender();
        cb();
      }, minLoadingTime - (Date.now() - startInitialLoading));
    }
  }

  updateConfiguration() {
    if (!this.configuration) {
      this.configuration = {};
    }
    this.configuration.Json = Commons.cloneDeep(this.arrangement.toJSON());
  }

  getStageAsConfiguration() {
    return this.configuration;
  }

  createArrangement() {
    return new Arrangement();
  }

  createWkfgBackendApi() {
    return new Wkfg2BackendApi(
      this.settings.wkfgBackendUrl,
      this.createWkfgTypeConverter(),
      async (metadata) => {
        this.richMetadata = new RichMetadata(metadata);
        await this.richMetadata.init();
        return metadata;
      }
    );
  }

  createDefaultConfiguration(params) {
    if (params?.code) {
      return this.createConfigurationFromCode(params.code);
    } else {
      return {};
    }
  }

  async createConfigurationFromCode(code) {
    const cfg = await APP.richMetadata.getJsonFromCfgCode(code);
    return cfg;
  }

  parseParams() {
    let params = {};
    const exhibitionSelection = matchPath(window.location.hash, {
      path: "#/exhibitions",
      exact: true,
    });
    if (exhibitionSelection) return params;

    const boothSelection = matchPath(window.location.hash, {
      path: "#/:exhibitionId/booths/",
      exact: true,
    });
    if (boothSelection) {
      params.exhibitionId = boothSelection.params.exhibitionId;
      return params;
    }

    const cfgStart = matchPath(window.location.hash, {
      path: "#/:exhibitionId/:boothId/configurator",
      exact: true,
    });
    if (cfgStart) {
      params.exhibitionId = cfgStart.params.exhibitionId;
      params.boothId = cfgStart.params.boothId;
      return params;
    }

    const inspirationEditorWithCode = matchPath(window.location.hash, {
      path: "#/:boothId/configurator/:code",
      exact: true,
    });
    if (inspirationEditorWithCode) {
      params.boothId = inspirationEditorWithCode.params.boothId;
      params.code = inspirationEditorWithCode.params.code;
      return params;
    }

    const inspirationEditor = matchPath(window.location.hash, {
      path: "#/:boothId/configurator/",
      exact: true,
    });
    if (inspirationEditor) {
      params.boothId = inspirationEditor.params.boothId;
      return params;
    }

    const loadCfg = matchPath(window.location.hash, {
      path: "#/:exhibitionId?/:boothId/configurator/:code",
      exact: true,
    });
    if (loadCfg) {
      params.exhibitionId = loadCfg.params.exhibitionId;
      params.boothId = loadCfg.params.boothId;
      params.code = loadCfg.params.code;
      return params;
    }
  }

  dirty() {
    this.arrangement.partslist.update();
    super.dirty();
  }

  update3d() {
    this.arrangement.partslist.update();
    super.update3d();
  }

  configurationFotoSnapshots() {
    return [
      // {
      //   name: "Inspiration",
      //   direction: { x: 4, y: 1, z: 4 },
      //   object: { x: 4, y: 2.8, z: 12 },
      //   target: { x: 0, y: 2, z: 0 },
      //   hideObjectsByName: ["ground", "coordinateOffset"],
      //   zoomTo: false,
      //   extraZoom: 1,
      //   backgroundColor: 0xf0f0f0,
      //   backgroundAlpha: 1,
      //   renderWidth: 268,
      //   renderHeight: 150,
      //   mimeType: "image/jpeg",
      // },
      {
        name: "Wireframe",
        direction: { x: 4, y: 4, z: 4 },
        object: { x: 0, y: 13, z: 0 },
        target: { x: 0, y: 0, z: 0 },
        hideObjectsByName: ["ground", "coordinateOffset", "hall20220310.glb", "sky"],
        zoomTo: false,
        extraZoom: 1,
        backgroundColor: 0xf0f0f0,
        backgroundAlpha: 1,
        renderWidth: 2000,
        renderHeight: 2000,
        mimeType: "image/jpeg",
        beforeScreenshotCallback: () => {
          const bbox = APP.arrangement.booth.getBox();
          const cameraSize = Math.max(...[Math.abs(bbox.min.x), Math.abs(bbox.max.x), Math.abs(bbox.min.z), Math.abs(bbox.max.z)])
          const margin = 1;

          Scenes.filter(STAGE.scene, (o) => o.material).forEach(
            (o) => (o.material.wireframe = true)
          );
          STAGE.camera = STAGE.orthographicCamera;
          STAGE.camera.position.set(0, 12, 0);
          STAGE.camera.lookAt(0, 0, 0);
          STAGE.camera.left = -margin - cameraSize;
          STAGE.camera.right = margin + cameraSize;
          STAGE.camera.bottom = -margin - cameraSize;
          STAGE.camera.top = margin + cameraSize;
          STAGE.camera.updateProjectionMatrix();
          STAGE.renderSceneOnce();
        },
        afterScreenshotCallback: () => {
          Scenes.filter(STAGE.scene, (o) => o.material).forEach(
            (o) => (o.material.wireframe = false)
          );
          STAGE.camera = STAGE.perspectiveCamera;
          STAGE.renderSceneOnce();
        },
      },
      {
        name: "FrontView",
        direction: { x: 4, y: 4, z: 4 },
        object: { x: 0, y: 3, z: 12 },
        target: { x: 0, y: 2, z: 0 },
        hideObjectsByName: ["ground", "coordinateOffset"],
        zoomTo: false,
        extraZoom: 1,
        backgroundColor: 0xf0f0f0,
        backgroundAlpha: 1,
        renderWidth: 1200,
        renderHeight: 800,
        mimeType: "image/jpeg",
      },
      {
        name: "SideView",
        direction: { x: 4, y: 4, z: 4 },
        object: { x: 5, y: 3, z: 12 },
        target: { x: 0, y: 2, z: 0 },
        hideObjectsByName: ["ground", "coordinateOffset"],
        zoomTo: false,
        extraZoom: 1,
        backgroundColor: 0xf0f0f0,
        backgroundAlpha: 1,
        renderWidth: 1200,
        renderHeight: 800,
        mimeType: "image/jpeg",
      },
    ];
  }

  // createRichMetadata() {
  //   this.richMetadata = new RichMetadata(this.metadata);
  //   this.richMetadata.init();
  //   return this.richMetadata;
  // }
}

$.fn.configurator = function (settings) {
  settings.autosaveAndRestore = false;
  return new App(this, settings);
};

if (DeviceDetection.isIE()) {
  alert(
    I18N(
      "Dieser Browser wird nicht mehr unterstützt. Um die Anwendung zu nutzen, verwenden Sie bitte einen aktuellen Browser, wie z.B. Edge, Firefox oder Chrome."
    )
  );
}
